import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import {
  FormComponent,
  FormJob,
  clearTypeOperationData,
  FormVehicle
} from '@app/src/views/StepOne/form';
import { setPrintGeneral, cleanPrintGeneral } from '@app/src/views/StepTwo/channelPublication';
import { CATEGORIES, CATEGORY_ALIAS } from '@app/src/config/categories';

const isClient = isClientEnv();

export const StepOne: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];

  useEffect(() => {
    if (print && print.general && categoryConfig && print.general.category === categoryConfig.id ) {
      dispatch(setPrintGeneral(print.general));
    } else {
      dispatch(setPrintGeneral({category: categoryConfig.id}));
    }
    return () => {
      dispatch(clearTypeOperationData());
      dispatch(cleanPrintGeneral());
    }
  }, []);

  return(
  <React.Fragment>
    {
      categoryConfig.alias === CATEGORY_ALIAS.INMUEBLE &&
        <FormComponent />
    }
    {
      (categoryConfig.alias === CATEGORY_ALIAS.EMPLEO || categoryConfig.alias === CATEGORY_ALIAS.OPORTUNIDAD || categoryConfig.alias === CATEGORY_ALIAS.EDUCACION) &&
        <FormJob />
    }
    {
      categoryConfig.alias === CATEGORY_ALIAS.VEHICULO &&
      <FormVehicle />
    }
    <ModalErrorFeature />
  </React.Fragment>
)};
